function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "fire copy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-page-/-Student",
  transform: "translate(-49.000000, -213.000000)",
  fill: "#FF5100",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(49.000000, 211.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "fire-copy",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.8964836,5.30632422 C7.75115051,3.46019727 9.22612445,0.854515625 9.28945169,0.746207031 C9.38127618,0.592078125 9.38096643,0.402455078 9.2886601,0.248591797 C9.19638818,0.0947285156 9.02609298,0 8.84182449,0 C7.22274667,0 5.95489409,0.443792969 5.07350974,1.31912695 C3.56745727,2.81472852 3.63732374,5.1425 3.66716325,6.13650195 C3.6705017,6.24663672 3.67332389,6.34176367 3.67332389,6.41245313 C3.67332389,7.15049219 3.79605483,7.83182031 3.90436506,8.43299609 C3.97416268,8.82041016 4.03442681,9.15496484 4.04516491,9.41793359 C4.05662576,9.6995625 4.00331386,9.76404297 4.00107676,9.76666602 C3.99347061,9.77539844 3.93010895,9.80787109 3.75891891,9.80787109 C3.56363699,9.80787109 3.41970519,9.7463125 3.29212146,9.60835352 C2.79390131,9.06936719 2.75944992,7.59777148 2.85471611,6.79714453 C2.87175251,6.65596484 2.82546168,6.51451953 2.72747655,6.40840234 C2.62952583,6.30228516 2.48924224,6.24158984 2.34197199,6.24158984 C1.00160285,6.24158984 0,8.35623047 0,10.2469492 C0,11.1357637 0.185335418,12.006416 0.550809291,12.8348008 C0.904133971,13.635627 1.40792967,14.3583262 2.04836077,14.9829102 C3.38198419,16.2836426 5.14045076,17 6.99975908,17 C8.86660472,17 10.6245895,16.2937695 11.9499872,15.011498 C13.2719433,13.7324805 14,12.040416 14,10.2468828 C14,7.95849023 12.1439957,6.03851953 10.8964836,5.30632422 Z",
  id: "Path"
})))));

var SvgFire = function SvgFire(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFire, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fire.f76f554b.svg";
export { ForwardRef as ReactComponent };